import { NavLink, useLocation } from 'react-router-dom';

export const BottomNav = ({ items }) => {
  const location = useLocation();

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-[#D1D1CD] px-1 py-1.5 z-50 pb-safe">
      <div className="flex justify-around">
        {items.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            data-testid={`bottom-nav-${item.label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center min-w-[56px] py-1.5 px-2 rounded-lg text-[10px] font-medium transition-colors ${
                isActive
                  ? 'text-[#2E4632] bg-[#2E4632]/5'
                  : 'text-[#5C5C5C]'
              }`
            }
          >
            <item.icon className={`w-5 h-5 mb-0.5 ${location.pathname === item.path ? 'text-[#2E4632]' : ''}`} />
            <span className="text-[10px]">{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
